import { SweepEvent } from './SweepEvent';
export class VertexEvent extends SweepEvent {
    get Site() {
        return this.Vertex.point;
    }
    constructor(p) {
        super();
        this.Vertex = p;
    }
    get Polyline() {
        return this.Vertex.polyline;
    }
}
//# sourceMappingURL=VertexEvent.js.map